import * as React from 'react';
import * as classNames from 'classnames';
import CommentMessage, { ICommentMessageProp } from '../../commentMessage';
if (process.env.BROWSER) {
    require('./index.less');
}
export interface ICommentItemReplyProp {
    id: string;
    userName: string;
    messageProp: ICommentMessageProp;
    isWemediaUser?: boolean;
    isWemediaAuthor?: boolean;
}
export default class CommentItemReply extends React.PureComponent<ICommentItemReplyProp> {
    public render(): JSX.Element {
        const isWemediaUser = this.props.isWemediaUser || false;
        const isWemediaAuthor = this.props.isWemediaAuthor || false;
        return <div className={'comment-reply-item'}>
            <div className={'comment-reply-item-header'} >
                <div className={
                    classNames({
                        'comment-reply-item-username': true,
                        'comment-wemedia-user': isWemediaUser,
                        'comment-wemedia-author': isWemediaAuthor,
                    })
                }>
                    <span className={'comment-reply-item-username-text'}>
                        {this.props.userName}
                    </span>
                </div>
            </div>
            <CommentMessage  {...this.props.messageProp}  ></CommentMessage>
        </div>;
    }
}
